import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="border-t border-border bg-background mt-auto" data-id="element-44">
      <div className="container mx-auto px-4 py-8" data-id="element-45">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-46">
          <div data-id="element-47">
            <h3 className="font-semibold mb-3" data-id="element-48">Financial</h3>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-49">
              <li data-id="element-50">
                <Link to="/financial/mortgage-calculator" className="hover:text-primary transition-colors" data-id="element-51">
                  Mortgage Calculator
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/financial/emi-calculator" className="hover:text-primary transition-colors" data-id="element-53">
                  EMI Calculator
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/financial/tip-calculator" className="hover:text-primary transition-colors" data-id="element-55">
                  Tip Calculator
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-56">
            <h3 className="font-semibold mb-3" data-id="element-57">Text Tools</h3>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-58">
              <li data-id="element-59">
                <Link to="/text-tools/word-counter" className="hover:text-primary transition-colors" data-id="element-60">
                  Word Counter
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/text-tools/case-converter" className="hover:text-primary transition-colors" data-id="element-62">
                  Case Converter
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/text-tools/email-extractor" className="hover:text-primary transition-colors" data-id="element-64">
                  Email Extractor
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-65">
            <h3 className="font-semibold mb-3" data-id="element-66">Fun & Social</h3>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-67">
              <li data-id="element-68">
                <Link to="/fun/secret-santa" className="hover:text-primary transition-colors" data-id="element-69">
                  Secret Santa
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/fun/random-picker" className="hover:text-primary transition-colors" data-id="element-71">
                  Random Picker
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/fun/team-randomizer" className="hover:text-primary transition-colors" data-id="element-73">
                  Team Randomizer
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-74">
            <h3 className="font-semibold mb-3" data-id="element-75">Developer</h3>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-76">
              <li data-id="element-77">
                <Link to="/developer/password-generator" className="hover:text-primary transition-colors" data-id="element-78">
                  Password Generator
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/developer/json-formatter" className="hover:text-primary transition-colors" data-id="element-80">
                  JSON Formatter
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/developer/qr-generator" className="hover:text-primary transition-colors" data-id="element-82">
                  QR Generator
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-border text-center text-sm text-muted-foreground" data-id="element-83">
          <p data-id="element-84">&copy; 2025 Hpppy.com. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}